module.exports = __webpack_public_path__ + "img/logic-test.31125248.jpeg";